import styles from "./table.module.css";
import { useState, useEffect } from "react";
import { ContentCard, Row, Tag } from "@narmi/design_system";
import { Payment } from "./PaymentTable";
import { dateOptions } from "./PaymentDetailDrawer";
import { moneyFormatter } from "./PaymentTable";
import { PAYMENT_STATUSES } from "./codesets";

function RelatedPaymentRow({ payment }: { payment: Payment }) {
  return (
    <div className="padding--top--s">
      <ContentCard
        kind="button"
        paddingSize="s"
        onClick={() => window.open(`/fednow/payments/${payment.payment_identification}`, "_blank")}
      >
        <Row gapSize="m">
          <Row.Item>
            <p
              className="padding--bottom--xs fontWeight--semibold whiteSpace--truncate"
              style={{ maxWidth: "100%" }}
            >
              {payment.payment_identification}
            </p>
          </Row.Item>
          <Row.Item shrink>
            <div className="padding--bottom--xs">
              <Tag label={PAYMENT_STATUSES[payment.state]}></Tag>
            </div>
          </Row.Item>
        </Row>
        <Row>
          <Row.Item>
            <p>{new Date(payment.updated_at).toLocaleString("en-US", dateOptions)}</p>
          </Row.Item>
          <Row.Item shrink>
            <p>{moneyFormatter.format(payment.amount_cents / 100)}</p>
          </Row.Item>
        </Row>
      </ContentCard>
    </div>
  );
}

export default function RelatedPayments({
  original,
  includeOriginal = false,
}: {
  original: Payment;
  includeOriginal?: boolean;
}) {
  const [relatedPayments, setRelatedPayments]: [Array<Payment>, CallableFunction] = useState([]);

  async function fetchRelatedPayments() {
    const lookupRes = await fetch(
      `/v1/fednow/payments/${original.payment_identification}/related_payments`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    if (!lookupRes.ok) {
      return;
    }
    const data = await lookupRes.json();
    setRelatedPayments(data["results"]);
  }

  useEffect(() => {
    fetchRelatedPayments();
  }, [original]);

  if (!includeOriginal && relatedPayments.length === 0) {
    return null;
  }

  return (
    <div className={`${styles.transactionDetailContainer} margin--y padding--all`}>
      <h4 className="fontFamily--body">Related payments</h4>
      {includeOriginal && <RelatedPaymentRow payment={original} />}
      {relatedPayments.map((p: Payment) => (
        <RelatedPaymentRow payment={p} />
      ))}
    </div>
  );
}
